import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setNotificationPermission } from 'toolkits/redux/setting';
import PercentRoundedIcon from '@mui/icons-material/PercentRounded';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import { Card, Avatar, Typography, CardHeader, CardActionArea } from '@mui/material';

export default function NotificationPermission() {
  const dispatch = useDispatch();
  const { notificationPermissionPrompt: permission } = useSelector((state) => state.setting);

  const requestPermission = () => {
    if ('Notification' in window) {
      Notification.requestPermission().then((e) => {
        dispatch(setNotificationPermission(e));
      });
    }
    // handleClose();
  };

  useEffect(() => {
    if ('Notification' in window) {
      const handler = () => {
        dispatch(setNotificationPermission(Notification.permission));
      };
      handler();
      navigator.permissions.query({ name: 'notifications' }).then((notificationPerm) => {
        notificationPerm.onchange = handler;
      });
    }
  }, []);

  if (permission === 'denied') {
    return (
      <Typography width="100%" align="center" variant="subtitle1" color="error" fontSize={16}>
        {/* دسترسی اطلاعیه ها غیرفعال است. از قسمت تنظیمات دسترسی را روشن نمایید */}
        لطفا دسترسی اعلان ها را فعال نمایید
      </Typography>
    );
  }
  if (permission === 'default') {
    return (
      <Card elevation={8} sx={{ flex: 1, bgcolor: 'error.main', color: '#fff' }}>
        <CardActionArea onClick={requestPermission}>
          <CardHeader
            sx={{ p: 1 }}
            title={
              <Typography variant="subtitle1" fontSize={15}>
                از جدیدترین تخفیف ها با خبرم کن!
              </Typography>
            }
            avatar={
              <Avatar sx={{ bgcolor: 'transparent' }}>
                <NotificationsActiveRoundedIcon fontSize="small" />
              </Avatar>
            }
            action={
              <Avatar sx={{ bgcolor: 'transparent' }}>
                <PercentRoundedIcon fontSize="small" />
              </Avatar>
            }
          />
        </CardActionArea>
      </Card>
    );
  }

  return (
    <Typography width="100%" align="center" variant="caption" color="text.disabled">
      از جدیدترین تخفیف ها با خبر میشوید!
    </Typography>
  );
}
